<template>
<!-- 创客管理 -->
<section class="viewContainer">
  <!-- 顶部搜索框 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <el-form :inline="true" class="findform" :model="filters">
        <el-form-item label="关键词语：" style="display:flex;width:25%">
          <el-input v-model="filters.keyword" placeholder="请输入昵称/手机号" maxlength="20" style="width:90%;"/>
        </el-form-item>
        <el-form-item label="员工身份：" style="display:flex;width:25%">
          <el-select v-model="filters.isIn" style="width:90%;">
            <el-option v-for="(item,index) in arr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="引流时间：" style="display:flex;width:25%">
          <el-date-picker type="daterange" :title="value6" v-model="value6" value-format="yyyy-MM-dd" style="width:90%;"
          range-separator="至" start-placeholder="开始日期" @change="changetime" end-placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="所属城市：" style="display:flex;width:25%">
          <el-cascader v-model="chengshi" placeholder="请选择城市" :options="optionsList"
          style="width: 90%" filterable clearable @change="handleChange"/>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <el-col :span="18">
        <p class="model_top_title">创客管理</p>
        <span style="margin-left: 20px;color: #F56C6C;">引流客户数: {{userCount}}人</span>
      </el-col>
      <el-col :span="6">
        <!-- <el-button type="danger" @click="getExtension()">推广</el-button> -->
        <!-- <el-button @click="endSetUpCoCreation()" class="blackGoldCard">设置黑金卡佣金比例</el-button> -->
      </el-col>
    </section>
    <div class="table_container">
      <el-table :data="users" stripe border @selection-change="handleSelectionChange">
        <!-- <el-table-column type="selection" align="center"/> -->
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope">
            <span>{{scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="姓名" align="center">
            <template scope="scope">
            <span class="spanList"
              :title="scope.row.Name"
            >{{scope.row.Name}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="昵称" align="center">
            <template scope="scope">
            <span class="spanList" :title="scope.row.name">{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center" >
            <template scope="scope">
            <span class="spanList">{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属城市" align="center">
          <template scope="scope">
            <span class="spanList">{{scope.row.pname}}-{{scope.row.cname}}<span v-show="scope.row.scname">-{{scope.row.scname}}</span></span>
          </template>
        </el-table-column>
        <el-table-column label="员工身份" align="center" width="100">
          <template scope="scope">
            <span class="spanList">{{scope.row.isStaff}}</span>
          </template>
        </el-table-column>
        <el-table-column label="引流客户数" align="center" width="120">
            <template scope="scope">
            <span :style="{color: scope.row.drainageNumber == 0 ? '#ccc' : '#F56C6C'}"
            @click="endDrainage(scope.row)">{{scope.row.drainageNumber}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="CoPrice" label="总成交额" align="center">
          <template scope="scope">
            <span class="spanList"
              :title="'￥'+scope.row.CoPrice"
            > ￥{{scope.row.CoPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kedanjia" label="客单价" align="center">
            <template scope="scope">
            <span class="spanList"
              :title="scope.row.kedanjia"
            >{{scope.row.kedanjia}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="noWidthdrawMoney" label="钱包余额" align="center" width="120">
              <template scope="scope">
            <span class="spanList" :title="'￥'+scope.row.noWidthdrawMoney">
                ￥{{scope.row.noWidthdrawMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="widthdrawMoney" label="已提现金额" align="center" width="120">
            <template scope="scope">
            <span class="spanList" :title="'￥'+scope.row.widthdrawMoney">
                ￥{{scope.row.widthdrawMoney}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="allPrice" label="累计佣金" align="center" width="120">
            <template scope="scope">
            <span class="spanList" :title="'￥'+scope.row.allPrice">
                ￥{{scope.row.allPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="housekeeperName" label="所属行业" align="center" >
            <template scope="scope">
            <span class="spanList">{{scope.row.housekeeperName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="黑金卡佣金比例" align="center" width="230">
          <template scope="scope">
            <span v-if="scope.row.FirstCoRate >= 0" class="spanList">
              普通商品: 一级: <strong>{{scope.row.FirstCoRate}}%</strong> 二级: <strong>{{scope.row.SecondRate}}%</strong>
            </span>
            <br>
            <span v-if="scope.row.BlastFirstCoRate >= 0" class="spanList">
              特价商品: 一级: <strong>{{scope.row.BlastFirstCoRate}}%</strong> 二级: <strong>{{scope.row.BlastSecondCoRate}}%</strong>
            </span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="scopeExtension(scope.row)" class="handle"> <i class="el-icon-share"/> 推广 </span>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right;"/>
    </div>
  </div>
  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="dialogTable" :before-close="cancelForm" :show-close= false>
    <template v-slot:title>
      <ul class="drawer_title">
        <li>引流记录</li> <el-button type="danger" @click="cancelForm">关 闭</el-button>
      </ul>
    </template>
    <div class="drawer_div">
      <el-table :data="gridData" border ref="table">
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column property="UserName" label="客户姓名" align="center"/>
        <el-table-column property="RegistrationTime" label="注册时间" align="center"/>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleTabFive"
      :current-page="goodsPageIndex" :page-size="10" :total="goodsPagetotal" style="margin-top:15px;float:right"/>
    </div>
  </el-drawer>
  <!-- 设置创客佣金比例 -->
  <el-dialog :title="titleType" :visible.sync="brandVisible" width="50%">
    <el-form label-width="135px" class="dialogForm">
      <el-form-item label="一级共创抽佣比例:">
        <div class="elForm">
          <el-input v-model="oneCreateTogetherOrdinary" placeholder="请输入" maxlength="5"
          style="width: 46%" type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <template slot="prepend">普通商品</template>
          </el-input>
          <el-input v-model="createTogetherSpecialOfferTwo" placeholder="请输入" maxlength="5"
          style="width: 46%" type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <template slot="prepend">特价商品</template>
          </el-input>
        </div>
      </el-form-item>
      <el-form-item label="二级共创抽佣比例:">
        <div class="elForm">
          <el-input v-model="oneSecondRateOrdinary" placeholder="请输入" maxlength="5"
          style="width: 46%" type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <template slot="prepend">普通商品</template>
          </el-input>
          <el-input v-model="secondRateSpecialOfferTwo" placeholder="请输入" maxlength="5"
          style="width: 46%" type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')">
            <template slot="prepend">特价商品</template>
          </el-input>
        </div>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div class="preservation_div">
      <el-button @click="brandVisible = false"> 取消 </el-button>
      <el-button type="danger" @click="editSubmit()"> 确认 </el-button>
    </div>
  </el-dialog>
</section>
</template>
<script>
import { provincegetcountys } from '../../api/newOss';
import { postyljl, getUpdateCoCreationEnderRate } from "../../api/api";
import { makergetlist } from "../../api/attractInvestment";
export default {
  data() {
    return {
      show3:true,
      dataUserId: '', // 用户唯一标识
      
      brandVisible: false, // 设置创客佣金比例 - 弹框
      titleType: "设置创客佣金比例",

      oneCreateTogetherOrdinary: "", // 一级共创抽佣比例 - 普通
      createTogetherSpecialOfferTwo: "", // 一级共创抽佣比例 - 特价

      oneSecondRateOrdinary: "", // 二级共创抽佣比例 - 普通
      secondRateSpecialOfferTwo: "", // 二级共创抽佣比例 - 特价
      
      value:"",
      filters: {
        keyword: "",
        isIn:-1,
        createDateB: "", // 日期开始日期
        createDateE: "", // 日期结束日期
      },
      arr: [
        {
          Id: -1,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 0,
          Name: "否"
        }
      ],
      searchShow: false,
      users: [],
      total: 0,
      page: 1,
      selectedRow: "", // 选中的存下
      goodIdarr: [],
      arrUserIds: [], // 取用户id
      // 缓存
      oneFirstCoRate: "",
      BlastFirstCoRateTwo: "",
      oneSecondRate: "",
      BlastSecondCoRateTwo: "",
      
      pageIndex: 1,
      pageSize: 10,
      value6: '', // 引流时间
      chengshi: '', // 所在城市
      optionsList: [], // 列表省市
      provinceId: 0, // 省id
      cityId: 0, // 市id
      zoneId: 0, // 区县
      userCount: '', // 引流客户数

      dialogTable: false, // 抽屉详情
      gridData: [], // 引流记录列表
      goodsPageIndex: 1, // 详情页页码
      goodsPagetotal: 0, // 总条数

    };
  },
  methods: {
    // 获取创客管理列表
    gettogetherlist() {
      var loginParams = {
        keyword: this.filters.keyword,
        // isVip: this.filters.isIn,
        isStaff: this.filters.isIn, // 是否为员工  -1=全部、0=否、1=是
        startTime: this.filters.createDateB, // 开始时间
        endTime: this.filters.createDateE, // 结束时间
        pid: this.provinceId, // 省份ID 全部=0
        cid: this.cityId, // 城市ID 全部=0
        scid: this.zoneId, // 区县id
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      makergetlist(loginParams).then(data => {
        if (data.resultCode == 1) {
          this.users = data.resultObj.list; // 分页后的创客集合
          this.total = data.resultObj.totalcount; // 总记录数
          this.userCount = data.resultObj.total_drainage_num; // 引流客户数
        }else{
          this.users = [];
          this.total = 0;
        }
      }).catch(err => {
        this.users = [];
        this.total = 0;
      });
    },
    // 引流数
    endDrainage(row) {
      if(row.DrainageNumber == 0) { return false; }
      this.dataUserId = row.userId;
      this.dialogTable = true;
      this.goodsPageIndex = 1;
      this.drainageRecord();
    },
    // 引流记录
    drainageRecord(){
      var loginParams = {
        userId: this.dataUserId,
        pageIndex: this.goodsPageIndex,
        pageSize: 10
      };
      postyljl(loginParams).then(data => {
        this.gridData = data.ResultObj;
        this.goodsPagetotal = data.RowsCount;
      })
    },
    // 分页
    handleTabFive(val) {
      this.goodsPageIndex = val;
      this.drainageRecord();
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.gridData = [];
      this.dialogTable = false;
      clearTimeout(this.timer);
    },
    // 引流时间
    changetime() {
      if( this.value6 + "" == "null" ){
        this.value6 = ["",""]
      }
      this.filters.createDateB = this.value6[0];
      this.filters.createDateE = this.value6[1];
    },
    // 批量推广
    getExtension() {
      if(this.goodIdarr.length == 0){
        this.$swal({
          text:"请选择需要推广项",
          type:"warning"
        })
        return false
      }
      var youfou = 0;
      for(var i=0; i < this.selectedRow.length; i++) {
        var theRow = this.selectedRow[i];
        if(theRow.IsVipName == '否') {
          youfou = 1;
        }
      }
      if (youfou == 1) {
        this.$swal({
          type:'warning',
          text: '所选项中共创有非会员，是否继续生成推广二维码？',
          showCancelButton:true,
          cancelButtonText: '取消',
          confirmButtonText: '继续下载',
        }).then(res=>{
          if(res.value){
            this.getMassPromotion();
          }
        })
        return false;
      }
      if (youfou == 0) {
        this.getMassPromotion();
      }
    },
    // 执行 批量推广
    getMassPromotion() {
      for(var i=0; i< this.selectedRow.length; i++) {
        let newMember = this.selectedRow[i];
        let addParams = [
          { name: "invitationId", value: newMember.UserId },
          { name: "userName", value: newMember.Name },
          { name: "phone", value: newMember.Phone },
        ];
        let url = "/wxService/QRCode/GenGoldCCInvitationQrCode";
        this.downLoad(url, addParams);
        /*var obj = {
          invitationId: newMember.UserId, // 创客管理userId
          userName: newMember.Name, // 创客管理名称
          phone: newMember.Phone, // 创客管理手机号
        }
        getGenGoldCCInvitationQrCode(obj).then(data=>{
          if(data.ResultCode == 1){
            // data.ResultObj
            let address = data.ResultObj;
            let intercept = data.ResultMsg;
            this.getUrlBase64(address).then(base64 => {
              let link = document.createElement('a')
              link.href = base64
              link.download = intercept
              link.click()
            })
            this.gettogetherlist();
            // this.$swal({
            //   type:"success",
            //   text:"推广成功"
            // })
          }else if(data.ResultCode in {0:0,2:2}){
            this.$swal({
              type:'error',
              text: data.ResultMsg,
            })
          }
        })*/
      }
    },
    // 推广
    scopeExtension(row) {
      if(row.IsVip == 0) {
        this.$swal({
          type:'warning',
          text: '所选项中共创为非会员，是否继续生成推广二维码？',
          showCancelButton:true,
          cancelButtonText: '取消',
          confirmButtonText: '继续下载',
        }).then(res=>{
          if(res.value){
            var addParams = [
              { name: "invitationId", value: row.UserId },
              { name: "userName", value: row.Name },
              { name: "phone", value: row.Phone },
            ];
            var url = "/wxService/QRCode/GenGoldCCInvitationQrCode";
            this.downLoad(url, addParams);
          }
        })
        return false;
      }
      var addParams = [
        { name: "invitationId", value: row.UserId },
        { name: "userName", value: row.Name },
        { name: "phone", value: row.Phone },
      ];
      var url = "/wxService/QRCode/GenGoldCCInvitationQrCode";
      this.downLoad(url, addParams);
    },
    // 点击设置黑金卡佣金比例
    endSetUpCoCreation() {
      if(this.arrUserIds.length == 0){
        this.$swal({
          text:"请选择需要设置黑金卡佣金比例项",
          type:"warning"
        })
        return false
      }
      // 列表缓存回显
      this.oneCreateTogetherOrdinary = this.oneFirstCoRate; // 一级普通
      this.createTogetherSpecialOfferTwo = this.BlastFirstCoRateTwo; // 一级特价
      this.oneSecondRateOrdinary = this.oneSecondRate; // 二级普通
      this.secondRateSpecialOfferTwo = this.BlastSecondCoRateTwo; // 二级特价

      // 判断选中的 如果是多选,就不回显数据
      if (this.arrUserIds.length > 1) {
        this.oneCreateTogetherOrdinary = ""; // 一级普通
        this.createTogetherSpecialOfferTwo = ""; // 一级特价
        this.oneSecondRateOrdinary = ""; // 二级普通
        this.secondRateSpecialOfferTwo = ""; // 二级特价
      }
      this.brandVisible = true;
    },
    // 确认设置
    editSubmit() {

      // 一级共创 - 普通
      if ( this.oneCreateTogetherOrdinary == "" && this.oneCreateTogetherOrdinary == null ) {
        this.$swal({
          text: "请输入一级共创抽佣比例 - 普通",
          type: "warning",
        });
        return false;
      }
      if (!Number(this.oneCreateTogetherOrdinary) && Number(this.oneCreateTogetherOrdinary) < 0 || Number(this.oneCreateTogetherOrdinary) > 49.991){
        this.$swal({
          text: "一级共创抽佣比例-普通商品,需输入0-49.99之间的数字",
          type: "warning",
        });
        return false;
      }
      
      // 一级共创 - 特价
      if ( this.createTogetherSpecialOfferTwo == "" && this.createTogetherSpecialOfferTwo == null ) {
        this.$swal({
          text: "请输入一级共创抽佣比例 - 特价",
          type: "warning",
        });
        return false;
      }
      if (!Number(this.createTogetherSpecialOfferTwo) && Number(this.createTogetherSpecialOfferTwo) < 0 || Number(this.createTogetherSpecialOfferTwo) > 49.991){
        this.$swal({
          text: "一级共创抽佣比例-特价商品,需输入0-49.99之间的数字",
          type: "warning",
        });
        return false;
      }
      
      // 二级共创 - 普通
      if ( this.oneSecondRateOrdinary == "" && this.oneSecondRateOrdinary == null ) {
        this.$swal({
          text: "请输入二级共创抽佣比例 - 普通",
          type: "warning",
        });
        return false;
      }
      if (!Number(this.oneSecondRateOrdinary) && Number(this.oneSecondRateOrdinary) < 0 || Number(this.oneSecondRateOrdinary) > 49.991){
        this.$swal({
          text: "二级共创抽佣比例-普通商品,需输入0-49.99之间的数字",
          type: "warning",
        });
        return false;
      }
      
      // 二级共创 - 特价
      if ( this.secondRateSpecialOfferTwo == "" && this.secondRateSpecialOfferTwo == null ) {
        this.$swal({
          text: "请输入二级共创抽佣比例 - 特价",
          type: "warning",
        });
        return false;
      }
      if (!Number(this.secondRateSpecialOfferTwo) && Number(this.secondRateSpecialOfferTwo) < 0 || Number(this.secondRateSpecialOfferTwo) > 49.991){
        this.$swal({
          text: "二级共创抽佣比例-特价商品,需输入0-49.99之间的数字",
          type: "warning",
        });
        return false;
      }
      
      // 一级共创为 0 时，二级共创也要为 0 -普通商品
      // if (!Number(this.oneCreateTogetherOrdinary) && Number(this.oneCreateTogetherOrdinary) == 0 && Number(this.oneSecondRateOrdinary) > 0){
      //   this.$swal({
      //     text: "一级共创为 0 时，二级共创也要为 0 -普通商品",
      //     type: "warning",
      //   });
      //   return false;
      // }
      // 一级共创为 0 时，二级共创也要为 0 -特价商品
      // if (!Number(this.createTogetherSpecialOfferTwo) && Number(this.createTogetherSpecialOfferTwo) == 0 && Number(this.secondRateSpecialOfferTwo) > 0){
      //   this.$swal({
      //     text: "一级共创为 0 时，二级共创也要为 0 -特价商品",
      //     type: "warning",
      //   });
      //   return false;
      // }
      
      // 一级共创 普通商品佣金比例 + 二级共创 普通商品佣金比例不能>99.99
      // if ( Number(this.oneCreateTogetherOrdinary) + Number(this.oneSecondRateOrdinary) > 99.991 ){
      //   this.$swal({
      //     text: "一级共创&二级共创抽佣比例之和 不能>99.99 (普通商品)",
      //     type: "warning",
      //   });
      //   return false;
      // }

      // 一级共创 特价商品佣金比例 + 二级共创 特价商品佣金比例不能>99.99
      // if ( Number(this.createTogetherSpecialOfferTwo) + Number(this.secondRateSpecialOfferTwo) > 99.991 ){
      //   this.$swal({
      //     text: "一级共创&二级共创抽佣比例之和 不能>99.99 (特价商品)",
      //     type: "warning",
      //   });
      //   return false;
      // }
      
      // 接口入参
      let addParams = {
        coCreationEnderId: this.arrUserIds.join(','), // 用户id，多个用英文逗号（,）隔开

        firstCoRate: this.oneCreateTogetherOrdinary, // 一级共创抽佣比例 - 普通
        blastFirstCoRate: this.createTogetherSpecialOfferTwo, // 一级共创抽佣比例 - 特价

        secondRate: this.oneSecondRateOrdinary, // 二级共创抽佣比例 - 普通
        blastSecondCoRate: this.secondRateSpecialOfferTwo, // 二级共创抽佣比例 - 特价
      };
      // 调用接口
      getUpdateCoCreationEnderRate(addParams).then((data) => {
        if (data.ResultCode == 1) {
          this.brandVisible = false; // 弹框-消失
          this.gettogetherlist(); // 刷新列表
        }
      });
    },
    // scopeExtension(row) {
    //   if(row.IsVip == 0) {
    //     this.$swal({
    //       type:'warning',
    //       text: '所选项中共创有非会员，是否继续生成推广二维码？',
    //       showCancelButton:true,
    //       cancelButtonText: '取消',
    //       confirmButtonText: '继续下载',
    //     }).then(res=>{
    //       if(res.value){
    //         var obj = {
    //           invitationId: row.UserId, // 创客管理userId
    //           userName: row.Name, // 创客管理名称
    //           phone: row.Phone // 创客管理手机号
    //         }
    //         getGenGoldCCInvitationQrCode(obj).then(data=>{
    //           if(data.ResultCode == 1){
    //             let address = data.ResultObj;
    //             let intercept = data.ResultMsg;
    //             this.getUrlBase64(address).then(base64 => {
    //               let link = document.createElement('a')
    //               link.href = base64
    //               link.download = intercept
    //               link.click()
    //             })
    //             this.gettogetherlist();
    //             this.$swal({
    //               type:"success",
    //               text:"推广成功"
    //             })
    //           }else if(data.ResultCode in {0:0,2:2}){
    //             this.$swal({
    //               type:'error',
    //               text: data.ResultMsg,
    //             })
    //           }
    //         })
    //       }
    //     })
    //     return false;
    //   }
    //   var obj = {
    //     invitationId: row.UserId, // 创客管理userId
    //     userName: row.Name, // 创客管理名称
    //     phone: row.Phone // 创客管理手机号
    //   }
    //   getGenGoldCCInvitationQrCode(obj).then(data=>{
    //     if(data.ResultCode == 1){
    //       let address = data.ResultObj;
    //       let intercept = data.ResultMsg;
    //       this.getUrlBase64(address).then(base64 => {
    //         let link = document.createElement('a')
    //         link.href = base64
    //         link.download = intercept
    //         link.click()
    //       })
    //       this.gettogetherlist();
    //       this.$swal({
    //         type:"success",
    //         text:"推广成功"
    //       })
    //     }else if(data.ResultCode in {0:0,2:2}){
    //       this.$swal({
    //         type:'error',
    //         text: data.ResultMsg,
    //       })
    //     }
    //   })
    // },
    // getUrlBase64这个方法主要根据图片的url返回一个base64编码
    getUrlBase64(url) {
      return new Promise(resolve => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.width = 1280
          canvas.height = 1280
          ctx.drawImage(img, 0, 0, 1280, 1280)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },
    // 重置
    fnReset() {
      this.filters = {
        keyword: "",
        isIn:-1,
        createDateB: "", // 日期开始日期
        createDateE: "", // 日期结束日期
      };
      this.value6 = '';
      this.chengshi = '';
      this.provinceId = 0;
      this.cityId = 0;
      this.zoneId = 0;
      // this.pageIndex = 1;
      // this.gettogetherlist();
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.gettogetherlist();
    },
    // 复选框
    handleSelectionChange(val) {
      this.selectedRow = val;
      this.goodIdarr = [];
      this.arrUserIds = [];
      val.forEach(element => {
        this.goodIdarr.push(element.Id);
        this.arrUserIds.push(element.UserId);
        // 以下 需从列表获取回显参数
        this.oneFirstCoRate = element.FirstCoRate < 0 ? "" : element.FirstCoRate; // 一级普通
        this.BlastFirstCoRateTwo = element.BlastFirstCoRate < 0 ? "" : element.BlastFirstCoRate; // 一级特价
        this.oneSecondRate = element.SecondRate < 0 ? "" : element.SecondRate; // 二级普通
        this.BlastSecondCoRateTwo = element.BlastSecondCoRate < 0 ? "" : element.BlastSecondCoRate; // 二级特价
      });
    },
    cancelSearch() {
      this.searchShow = false;
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.gettogetherlist();
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0]; // 省
      this.cityId = val[1]; // 市
      this.zoneId = val[2]; // 区
    },
    // 查找省市
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else {delete province.children;}
          provinceOptions.push(province);
        });
        this.optionsList = provinceOptions;
        this.optionsList.unshift({value: 0, label: "全国"});
      })
    },
  },
  mounted() {
    this.getprovince(); // 所属城市
    this.gettogetherlist();
  }
};
</script>
<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.banner .toolbar {
  height: auto;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
}

/* 内容表格 */
.banner_table {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  position: relative;
}
/* 标题 */
.banner_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
.banner_table .el-col-22 p {
  width: 86px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.banner_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.ban_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.ban_tab p {
  float: left;
  color: #b2b2b2;
  width: 30%;
}
/* .ban_tab p img{
  margin-top:10px
} */
.ban_tab p:first-child {
  margin-left: 10%;
}

/* 新增页面 */
.add_banner {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  margin-top: 10px;
  height: 801px;
  position: relative;
}
.add_banner .el-col-24 {
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.add_banner .el-col-24 p {
  width: 110px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin: 0;
  margin-left: 20px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
}
.add_banner input {
  border: 1px solid #f2f2f2;
  background: #fff !important;
}
/* 设置黑金卡佣金比例 */
.blackGoldCard {
  width: 160px;
  border: none;
  background-color: #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  float: right;
  margin-top: 10px;
  margin-right: 10px;
}
/* 弹框内部样式 */
.preservation_div {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.elForm {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// together.vue?0e8b0eb7